var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF05F25E-CA9C-431C-BD97-3ADC0791B183") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete-photo",
    fill: "#9C9C9C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/delete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.984062153,15.63596 C0.984062153,15.8321154 1.1430677,15.991121 1.33922309,15.991121 L10.3544506,15.991121 C10.550606,15.991121 10.7096115,15.8321154 10.7096115,15.63596 L10.7096115,4.12851498 L0.984062153,4.12851498 L0.984062153,15.63596 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84039956,1.63215982 L8.84039956,0.355160932 C8.84039956,0.159005549 8.68139401,0 8.48523862,0 L3.20843507,0 C3.01227969,0 2.85327414,0.159005549 2.85327414,0.355160932 L2.85327414,1.63215982 L2.85327414,1.85413541 L2.85327414,2.07611099 L0.370681465,2.07611099 C0.174526082,2.07611099 0.0155205327,2.23511654 0.0155205327,2.43127192 L0.0155205327,3.32940289 C0.0155205327,3.52554051 0.174526082,3.68456382 0.370681465,3.68456382 L0.984062153,3.68456382 L10.7096115,3.68456382 L11.3229922,3.68456382 C11.5191476,3.68456382 11.6781532,3.52554051 11.6781532,3.32940289 L11.6781532,2.43127192 C11.6781532,2.23511654 11.5191476,2.07611099 11.3229922,2.07611099 L8.84039956,2.07611099 L8.84039956,1.85413541 L8.84039956,1.63215982 Z M7.50854606,2.0030899 L4.18512764,2.0030899 L4.18512764,1.85411765 L4.18512764,1.63214206 L4.18512764,1.3318535 L7.50854606,1.3318535 L7.50854606,1.63215982 L7.50854606,1.85413541 L7.50854606,2.0030899 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ac0f6531f40a36eab66ec564a08ef984.svg";
export { ForwardRef as ReactComponent };